import { ReactNode } from 'react';
import { SubscriptionStatusesEnum } from '@thinknet-gmbh/platform-common';

import { useGetCurrentSubscription } from 'src/hooks/subscriptions/get-current-subscription.hook';
import SoftwarePlansModal from 'src/components/software-plans-modal/software-plans-modal.component';

const SubscriptionProvider = ({ children }: { children: ReactNode }) => {
  const { subscription, loading } = useGetCurrentSubscription();
  const { _id: subscriptionId, subscriptionType, status, usedEmployeesPlacesCount } = subscription;

  return (
    <>
      {subscriptionType && !loading && status !== SubscriptionStatusesEnum.ACTIVE && (
        <SoftwarePlansModal
          subscriptionId={subscriptionId}
          usedEmployeesPlacesCount={usedEmployeesPlacesCount}
        />
      )}
      {children}
    </>
  );
};

export default SubscriptionProvider;
